import React from "react";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import ButtonCustom from "./ButtonCustom/ButtonCustom";

interface IProps {
  onClick: () => void;
}

const ReturnButton: React.FC<IProps> = ({ onClick }: IProps) => {
  return (
    <ButtonCustom
      title={"Wstecz"}
      className={"button-default"}
      Icon={HiOutlineArrowNarrowLeft}
      iconPosition={"left"}
      onClick={onClick}
    />
  );
};

export default ReturnButton;
